export default "__VITE_ASSET__CX2sz_Gd__"